import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const NegocioContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function NegocioProvider({ children }) {
  const [nombreNegocio, setNombreNegocio] = useState('Pollería');
  const [iconoNegocio, setIconoNegocio] = useState('🍗');

  useEffect(() => {
    axios.get(`${API}/configuracion`)
      .then(({ data }) => {
        if (data.nombre_negocio) setNombreNegocio(data.nombre_negocio);
        if (data.icono_negocio) setIconoNegocio(data.icono_negocio);
      })
      .catch(() => {});
  }, []);

  const updateConfig = async (patch) => {
    const { data } = await axios.put(`${API}/configuracion`, patch);
    if (data.nombre_negocio) setNombreNegocio(data.nombre_negocio);
    if (data.icono_negocio) setIconoNegocio(data.icono_negocio);
    return data;
  };

  return (
    <NegocioContext.Provider value={{ nombreNegocio, iconoNegocio, updateConfig }}>
      {children}
    </NegocioContext.Provider>
  );
}

export function useNegocio() {
  const ctx = useContext(NegocioContext);
  if (!ctx) throw new Error('useNegocio must be within NegocioProvider');
  return ctx;
}
